import React from "react";
import { IconButton, Tooltip } from "@mui/material";

const PRIMARIO = "#5656FF";

const BotonCircular = ({ icono, titulo, onClick, peligro = false, disabled = false }) => (
  <Tooltip title={titulo}>
    <span>
      <IconButton
        onClick={onClick}
        aria-label={titulo}
        size="small"
        disabled={disabled}
        sx={{
          width: 32,
          height: 32,
          border: `1px solid ${peligro ? "#fca5a5" : "#e5e7eb"}`,
          color: peligro ? "#ef4444" : "#374151",
          bgcolor: "#fff",
          "&:hover": { bgcolor: "#fff", borderColor: peligro ? "#ef4444" : PRIMARIO, color: peligro ? "#ef4444" : PRIMARIO },
        }}
      >
        {icono}
      </IconButton>
    </span>
  </Tooltip>
);

export default BotonCircular;
